import { render, staticRenderFns } from "./placeedit.vue?vue&type=template&id=1e945262&"
import script from "./placeedit.vue?vue&type=script&lang=js&"
export * from "./placeedit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports